// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getMessaging } from "firebase/messaging";
import { getFunctions } from "firebase/functions";
import { getStorage } from "firebase/storage";

// استخدام متغيرات بيئية مخفية
// في وضع الإنتاج، يجب وضع هذه القيم في ملف .env
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyAfpEXpKaRnVTfOdRpZaHBhoGCGlsHbVE8",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "atdelivery-9d139.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "atdelivery-9d139",
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL || "https://atdelivery-9d139.firebaseio.com",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "atdelivery-9d139.appspot.com",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "76043371440",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:76043371440:web:d2a57531269b997892cc75",
  vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY || "BJh7mFmi44Du5fvsaayT-niXBM4SNrfrG3o8jl3Bf8g7TnUPzg4f3tuxBDfIWHv5zOudwfpi2a5axmL52TBWppw"
};

// منع سجلات التصحيح في وضع الإنتاج
if (process.env.NODE_ENV === 'production') {
  // تعطيل إخراج وحدة التحكم في الإنتاج
  const noop = () => {};
  const disableConsole = () => {
    const originalConsoleLog = console.log;
    const originalConsoleInfo = console.info;
    const originalConsoleWarn = console.warn;
    const originalConsoleError = console.error;
    
    // الاحتفاظ بسجلات الأخطاء الحرجة فقط
    console.log = noop;
    console.info = noop;
    console.warn = noop;
    
    // الاحتفاظ بوظيفة الأخطاء للمشاكل الحرجة
    console.error = function() {
      if (arguments[0]?.includes('critical') || arguments[0]?.includes('حرج')) {
        originalConsoleError.apply(console, arguments);
      }
    };
    
    // إعادة تعريف Object.defineProperty لمنع إعادة تعيين وحدة التحكم
    const originalDefineProperty = Object.defineProperty;
    Object.defineProperty = function(obj, prop, descriptor) {
      if (obj === window && (prop === 'console' || prop === '_console')) {
        return obj;
      }
      return originalDefineProperty.call(Object, obj, prop, descriptor);
    };
  };
  
  // تشغيل خاصية تعطيل وحدة التحكم
  try {
    disableConsole();
  } catch (e) {
    // لا تفعل شيئًا إذا فشل
  }
}

// تهيئة Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const functions = getFunctions(app);
export const storage = getStorage(app);

// تهيئة Messaging
export let messaging = null;
try {
  if (
    typeof window !== 'undefined' && 
    typeof navigator !== 'undefined' &&
    (window.location.protocol === 'https:' || window.location.hostname === 'localhost') &&
    'serviceWorker' in navigator
  ) {
    messaging = getMessaging(app);
    if (process.env.NODE_ENV !== 'production') {
      console.log('✅ تم تهيئة Firebase Messaging بنجاح');
    }
  }
} catch (error) {
  if (process.env.NODE_ENV !== 'production') {
    console.error('❌ خطأ في تهيئة Firebase Messaging:', error);
  }
}

// إعداد كائن بالمعلومات المخفية لمنع ظهورها
const secureApp = {
  name: app.name,
  isConnected: () => true,
  checkConnection: () => "متصل"
};

export default secureApp;
